import React, { useState } from 'react';
import PasswordChecklist from '../../../../_components/PasswordChecklist'

import { connect } from 'react-redux';
import { Container } from 'react-bootstrap'
import { userService } from '../../../../_services/user.service';
import { alertActions } from '../../../../_actions/alert.actions';
import { isValidPassword } from '../../../../_helpers/regex'

function ChangePassword({ dispatch }) {
  const [newPassword, setNewPassword] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [passwordRequest, setPasswordRequest] = useState(false);
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const handleChangePassword = () => {
    setPasswordRequest(true);

    userService.changePassword(currentPassword, newPassword, confirmNewPassword)
      .then((response) => {
        setPasswordRequest(false);
        setNewPassword('');
        setCurrentPassword('');
        setConfirmNewPassword('');
        dispatch(alertActions.success('Password changed!'));
      })
      .catch((error) => {
        setPasswordRequest(false);
        dispatch(alertActions.error(error.response.data.currentPassword));
      })
  }

  return <Container fluid>
    <div className="row">
      <div className="col-9">
        <div className="card">
          <div className="card-body">
            <h4 className="font-weight-bold">Change Your Password</h4>
            <br />

            <form>
              <div className="form-group text-right">
                <div className="row">
                  <div className="col-3 my-auto">
                    Current Password
                  </div>
                  <div className="col-8">
                    <input onChange={e => setCurrentPassword(e.target.value)} value={currentPassword} type="password" className="form-control" />
                  </div>
                </div>
              </div>
              <div className="form-group text-right my-4">
                <div className="row">
                  <div className="col-3 my-auto">
                    New Password
                  </div>
                  <div className="col-8">
                    <input onChange={e => setNewPassword(e.target.value)} value={newPassword} type="password" className="form-control" />
                  </div>
                </div>
              </div>
              <div className="form-group text-right">
                <div className="row">
                  <div className="col-3 my-auto">
                    Retype New Password
                  </div>
                  <div className="col-8">
                    <input onChange={e => setConfirmNewPassword(e.target.value)} value={confirmNewPassword} type="password" className="form-control" />
                  </div>
                </div>
              </div>

              <br />

              <div className="form-group text-left">
                <div className="row">
                  <div className="col px-5">
                    <PasswordChecklist password={newPassword} />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="card-footer text-right">
            <button onClick={handleChangePassword}
              disabled={isValidPassword(newPassword) === false || newPassword !== confirmNewPassword || currentPassword.trim() === ''}
              type="submit" className="btn btn-primary px-5">{passwordRequest ? 'Changing...' : 'Change Your Password'}</button>
          </div>
        </div>
      </div>
    </div>
  </Container>
}

export default connect()(ChangePassword);